var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Loading } from '@folio/stripes/components';
import { Pluggable } from '@folio/stripes/core';
import React, { useMemo } from 'react';
import { useQueryBuilderResultViewerSources } from '../../../../hooks/useQueryBuilderSources';
import { t } from '../../../../services';
export var ListInformationResultViewer = function (_a) {
    var _b = _a.refreshTrigger, refreshTrigger = _b === void 0 ? 0 : _b, _c = _a.setColumnControlList, setColumnControlList = _c === void 0 ? function () { } : _c, _d = _a.listId, listId = _d === void 0 ? '' : _d, fqlQuery = _a.fqlQuery, _e = _a.entityTypeId, entityTypeId = _e === void 0 ? '' : _e, _f = _a.setDefaultVisibleColumns, setDefaultVisibleColumns = _f === void 0 ? function () { } : _f, _g = _a.visibleColumns, visibleColumns = _g === void 0 ? [] : _g, refreshInProgress = _a.refreshInProgress;
    var fqlQueryParsed = useMemo(function () { return (fqlQuery ? JSON.parse(fqlQuery) : undefined); }, [fqlQuery]);
    return (React.createElement(Pluggable, __assign({ type: "query-builder", componentType: "viewer", showQueryAccordion: true, fqlQuery: fqlQueryParsed, headline: function (_a) {
            var totalRecords = _a.totalRecords;
            return t('mainPane.subTitle', { count: totalRecords === 'NaN' ? 0 : totalRecords });
        }, refreshInProgress: refreshInProgress, refreshTrigger: refreshTrigger }, useQueryBuilderResultViewerSources(entityTypeId, listId, visibleColumns), { visibleColumns: visibleColumns, onSetDefaultVisibleColumns: setDefaultVisibleColumns, onSetDefaultColumns: setColumnControlList, height: 500, contentQueryKeys: visibleColumns }),
        React.createElement(Loading, null)));
};
